// src/components/ReceiptView.jsx
import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import DashboardLayout from "./DashboardLayout";
import "./invoice-form.css";

const API_BASE = process.env.REACT_APP_API_BASE || "https://dairy.server.statify.co.ke";

function ReceiptViewContent() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [receipt, setReceipt] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => { load(); }, [id]); // eslint-disable-line

  async function load() {
    setLoading(true);
    try {
      const res = await fetch(`${API_BASE}/api/receipts/${id}`);     
      if (!res.ok) throw new Error("Failed to fetch");
      const data = await res.json();
      setReceipt(data);
    } catch (err) {
      console.error("Failed to load receipt:", err);
      alert("Failed to load receipt details. Please check server connection.");
      navigate("/receipts");
    } finally {
      setLoading(false);
    }
  }

  if (loading) return <div className="form-card"><p>Loading...</p></div>;
  if (!receipt) return null;

  return (
    <div className="form-card">
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <h2>Receipt {receipt.receipt_number || `#${receipt.id}`}</h2>
        <div>
          <button className="btn-ghost small-btn" onClick={() => navigate("/receipts")}>Close</button>
        </div>
      </div>

      <div style={{ marginTop: 12 }}>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
          <div>
            <div className="field"><label>Customer</label><div className="muted">{receipt.customer?.name || receipt.customer_name || "-"}</div></div>
            <div className="field"><label>Transaction Type</label><div className="muted">{receipt.transaction_type || "-"}</div></div>
            <div className="field"><label>Invoice No</label><div className="muted">{receipt.invoice_id || "-"}</div></div>
          </div>
          <div>
            <div className="field"><label>Receipt ID</label><div className="muted">{receipt.receipt_number || `#${receipt.id}`}</div></div>
            <div className="field"><label>Date</label><div className="muted">{receipt.date ? new Date(receipt.date).toLocaleString() : "-"}</div></div>
            <div className="field"><label>Payment Ref</label><div className="muted">{receipt.payment_reference || "-"}</div></div>
          </div>
        </div>

        <div style={{ marginTop: 18 }}>
          <label>Description</label>
          <div className="muted">{receipt.description || "-"}</div>
        </div>

        <div style={{ marginTop: 18 }}>
          <h4>Lines</h4>
          <table className="compact-table">
            <thead>
              <tr><th>No.</th><th>Product</th><th>Qty</th><th>Unit Cost</th><th>Amount</th></tr>
            </thead>
            <tbody>
              {(receipt.lines || []).length === 0 && <tr><td colSpan={5}>No lines</td></tr>}
              {(receipt.lines || []).map((ln, i) => (
                <tr key={i}>
                  <td>{ln.line_no || i + 1}</td>
                  <td>{(ln.product_name || ln.product?.name || "") + (ln.product_id ? ` (${ln.product_id})` : "")}</td>
                  <td>{ln.quantity ?? ln.qty ?? "-"}</td>
                  <td>{Number(ln.unit_cost ?? ln.unit_price ?? 0).toFixed(2)}</td>
                  <td>{Number(ln.amount ?? ln.total_amount ?? 0).toFixed(2)}</td>
                </tr>
              ))}
            </tbody>
          </table>

          <div style={{ marginTop: 12, textAlign: "right" }}><strong>Total: {Number(receipt.total_amount || 0).toFixed(2)}</strong></div>
        </div>
      </div>
    </div>
  );
}

export default function ReceiptView(props) {
  const { noLayout } = props || {};
  const content = <ReceiptViewContent {...props} />;
  if (noLayout) return content;
  return <DashboardLayout>{content}</DashboardLayout>;
}
